export const ADDRESS_VERIFICATION_SINGLE_INPUT = {
    testName: 'address_verification_single_input',
    variants: {
        on: 'new_address_verification',
        off: 'old_address_verification',
    },
};
